export function sanitizeQtyInput(value) {
    let next = String(value).replace(',', '.').replace(/[^0-9.]/g, '')
    const parts = next.split('.')
    if (parts.length > 2) next = parts[0] + '.' + parts.slice(1).join('')

    if (next.includes('.')) {
        const [intPart, decPart] = next.split('.')
        const normalizedInt = intPart.replace(/^0+(?=\d)/, '') || '0'
        next = normalizedInt + '.' + (decPart ?? '')
    } else {
        next = next.replace(/^0+(?=\d)/, '')
    }

    return next
}

export function handleQtyKeyDown(e) {
    if (['+', '-'].includes(e.key)) e.preventDefault()
}